module.exports = __webpack_public_path__ + "static/media/example05-03.f1ed555f.svg";